define('CartToQuote.DynamicCSS', [
    'jQuery',
    'underscore'
], function CartToQuoteDynamicCSS(
    jQuery,
    _
) {
    'use strict';

    var CSS_DISPLAY_NONE = '{ display: none !important; }';

    return {
        addStylesToPage: function addStylesToPage(cssContent, styleId) {
            var id = 'custom-additional-styles-' + (styleId || 'id');
            var $style = jQuery('head').find('#' + id);

            if (!$style.length) {
                $style = jQuery('head').append('<style type="text/css" id="' + id + '"></style>')
                    .find('#' + id);
            }

            $style.html(cssContent);
        },

        removeStylesFromPage: function removeStylesFromPage(styleIds) {
            _(styleIds).each(function eachId(styleId) {
                var id = 'custom-additional-styles-' + (styleId || 'id');
                jQuery('head').find('#' + id).remove();
            });
        },

        hideReorders: function hideReorders(revert) {
            var selectorsToHide = [
                '[data-view="Header.Menu.MyAccount"] [data-hashtag*="reorderItems"]',
                '[data-view="MenuItems.Collection"] [data-id="reorderitems"]'
            ];

            return revert ? this.removeStylesFromPage(['reorders']) : this.addStylesToPage(
                selectorsToHide.join(',\n') + ' ' + CSS_DISPLAY_NONE,
                'reorders'
            );
        },

        hideReturns: function hideReturns(revert) {
            var selectorsToHide = [
                '[data-view="Header.Menu.MyAccount"] [data-hashtag*="returns"]',
                '[data-view="MenuItems.Collection"] [data-id="returns"]'
            ];

            return revert ? this.removeStylesFromPage(['returns']) : this.addStylesToPage(
                selectorsToHide.join(',\n') + ' ' + CSS_DISPLAY_NONE,
                'returns'
            );
        },

        hideProductLists: function hideProductLists(revert) {
            var selectorsToHide = [
                '[data-view="AddToProductList"]',
                '[data-view="MenuItems.Collection"] [data-id="productlists"]'
            ];

            return revert ? this.removeStylesFromPage(['prodLists']) : this.addStylesToPage(
                selectorsToHide.join(',\n') + ' ' + CSS_DISPLAY_NONE,
                'prodLists'
            );
        }
    };
});
